import axios from "axios";

// 创建axios实例
const api = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/napi/api" : "/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器 - 添加认证令牌
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("user-storage")
      ? JSON.parse(localStorage.getItem("user-storage")).state.token
      : null;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // 处理常见错误
    if (error.response) {
      // 服务器返回错误状态码
      console.error("API Error:", error.response.status, error.response.data);
    } else if (error.request) {
      // 请求发出但没有收到响应
      console.error("API Error: No response received", error.request);
    } else {
      // 请求配置错误
      console.error("API Error:", error.message);
    }
    return Promise.reject(error);
  }
);

// API方法
export const apiService = {
  // 用户注册
  register: async (userData) => {
    return await api.post("/register", userData);
  },

  // 用户登录
  login: async (credentials) => {
    return await api.post("/login", credentials);
  },

  // 忘记密码
  forgotPassword: async (data) => {
    return await api.post("/forgot-password", data);
  },

  // 用户注销
  logout: async () => {
    return await api.post("/logout");
  },

  // 获取SDK临时下载链接
  getSdkDownloadLink: async (version = "x86_64") => {
    return await api.post("/download", null, { params: { version } });
  },

  // 创建订单（支付）
  createPayment: async (paymentData) => {
    return await api.post("/create-order", paymentData);
  },

  // 查询订单状态
  getOrderStatus: async (orderNo) => {
    return await api.get("/order/status", {
      params: { order_no: orderNo },
    });
  },
};

export default apiService;
